<template>
	<div class="h-screen flex w-full bg-img" id="page-login">
		<transition name="fade" appear>
			<div
				class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center"
			>
				<vx-card>
					<div slot="no-body" class="full-page-bg-color">
						<div class="vx-row">
							<div
								class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
							>
								<img
									src="@/assets/images/logo/logo.png"
									alt="Imagem acessar"
									class="mx-auto logo"
								/>
							</div>
							<div
								id="content-login"
								class="relative vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
							>
								<div class="p-8">
									<div class="vx-card__title mb-8">
										<h4 class="mb-4">Acessar</h4>
										<p>Acesse utilizando sua conta.</p>
									</div>
									<form
										id="form-login"
										@submit.prevent="acessar"
									>
										<vs-input
											name="cpf"
											icon="icon icon-user"
											icon-pack="feather"
											label="CPF"
											v-mask="'###.###.###-##'"
											v-model="cpf"
											class="w-full no-icon-border"
										/>

										<vs-input
											type="password"
											name="senha"
											icon="icon icon-lock"
											icon-pack="feather"
											label="Senha"
											v-model="senha"
											class="w-full mt-6 no-icon-border"
										/>

										<div
											class="flex flex-wrap justify-end mt-5 mb-8"
										>
											<router-link to="/senha/recuperar"
												>Esqueceu a senha?</router-link
											>
										</div>
										<div
											class="flex flex-wrap justify-center"
										>
											<ld-button
												class="w-full"
												buttonType="submit"
												>Acessar</ld-button
											>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</vx-card>

				<div class="flex justify-center p-5 mt-4">
					<h6>Versão {{ versao }}</h6>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import Autenticacao from "../../../models/Autenticacao";
import ErrorHelper from "../../../helpers/ErrorHelper";
import ComponentHelper from "../../../helpers/ComponentHelper";
import config from "../../../config";

export default {
	data() {
		return {
			cpf: null,
			senha: null,
			versao: config.version
		};
	},
	methods: {
		async acessar() {
			const loadingLogin = this.$vsloading({
				container: "#content-login",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				const { navigate } = await Autenticacao.acesssar(this.cpf, this.senha);

				ComponentHelper.deleteAllVsNotifications();
				navigate(({routeName, params}) => {
					this.$navigate({
						name: routeName,
						params
					});
				});

			} catch (error) {
				ErrorHelper.renderFormError("#form-login", error);
			} finally {
				loadingLogin.hide();
			}
		},

	}
};
</script>

<style lang="scss" scoped src="./login.scss"></style>
